import styles from './listenlive.module.scss';
import { IconAudioPlayButtonFilledShadow } from '@/assets/icons/IconAudioPlayButtonFilledShadow';
import { Link } from '../Link/Link';

export interface ListenLiveProps {
    link?: Link;
}

export function ListenLive(props: ListenLiveProps): React.JSX.Element {
    const link = props?.link;

    const content = (
        <div className={styles.listenLive}>
            <IconAudioPlayButtonFilledShadow className={styles.playIcon} aria-hidden />
            <p className={styles.listenLiveText}>listen live</p>
        </div>
    );

    if (link && link.href) {
        return (
            <Link
                href={link?.href}
                aria-label={link['aria_label']}
                target={link?.['link_target']}
                className={styles.listenLiveLink}
            >
                {content}
            </Link>
        );
    }

    return content;
}
